import { useEffect } from "react";
import Lenis from "lenis";
import { Navbar } from "../components/Navbar";
import { Hero } from "../components/sections/Hero";
import { ChiSono } from "../components/sections/ChiSono";
import { Competenze } from "../components/sections/Competenze";
import { Approccio } from "../components/sections/Approccio";
import { Collaborare } from "../components/sections/Collaborare";
import { Contatti } from "../components/sections/Contatti";
import { Footer } from "../components/sections/Footer";

export default function Portfolio() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <ChiSono />
        <Competenze />
        <Approccio />
        <Collaborare />
        <Contatti />
      </main>
      <Footer />
    </>
  );
}
